module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/main-visual-02b924bd4fc015024b3fd48c548b38a0.jpg";